import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateWizard, UpdateWizard, Wizard, WizardListResponse, WizardQueryParams } from '@frontend/wizard/types';

export class WizardClient extends APIClient {
    public static readonly endpoint = '/wizard-api/v1';

    public static async fetchWizards(queryParams?: ApiQueryParams<WizardQueryParams>): Promise<WizardListResponse> {
        return await this.apiPaginated<WizardListResponse, WizardQueryParams>(`${this.endpoint}/wizards`, queryParams);
    }

    public static async resolveWizards(ids: string[], field: string = 'id'): Promise<WizardListResponse> {
        return this.resolve<WizardListResponse>(`${this.endpoint}/wizards`, ids, field);
    }

    public static async deleteWizards(wizardIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/wizards-delete`, { ids: wizardIds });
        return await this.handleVoidResponse(response);
    }

    public static async postWizard(accountId: string, wizard: CreateWizard): Promise<Wizard> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/wizards`, wizard);
        return await this.handleResponse<Wizard>(response);
    }

    public static async fetchWizard(accountId: string, wizardId: string): Promise<Wizard> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}`);
        return await this.handleResponse<Wizard>(response);
    }

    public static async patchWizard(accountId: string, wizardId: string, screen: UpdateWizard): Promise<Wizard> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}`, screen);
        return await this.handleResponse<Wizard>(response);
    }

    public static async deleteWizard(accountId: string, wizardId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/wizards/${wizardId}`);
        return await this.handleVoidResponse(response);
    }
}
